export default __webpack_public_path__ + "static/media/pp-icon.3c8bc6dc.webp";